import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Picture } from "../../../Picture";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
var yandexLogoLink = 'https://static.beeline.ru/upload/images/b2c/redesign/yandex-plus.svg';
export var Sharing = /*#__PURE__*/memo(function (_ref) {
  var cardType = _ref.cardType,
    badgeClassName = _ref.badgeClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('sharing__numbers', cardType && "sharing__numbers--".concat(cardType)),
    "data-t-id": "components-Sharing"
  }, /*#__PURE__*/React.createElement("div", {
    className: badgeClassName
  }, /*#__PURE__*/React.createElement(Picture, {
    src: yandexLogoLink
  })));
});